import React, { useContext, useState } from "react"
import { Link } from "react-router-dom"

import NavLeft from "./NavLeft"
import NavRight from "./NavRight"

import { ConfigContext } from "../../../contexts/ConfigContext"
// import logo from "../../../assets/images/cms/ms.JPG"
import Logo from "../../../assets/images/cms/miraSD.png"
// import Logo from "../../../assets/images/cms/miraFaviIcon.png"

import * as actionType from "../../../store/actions"
import NavMiddle from "./NavMiddle/NavMiddle"
import { MoreVertical } from "react-feather"

const NavBar = () => {
  const [moreToggle, setMoreToggle] = useState(false)
  const configContext = useContext(ConfigContext)
  const {
    collapseMenu,
    headerBackColor,
    headerFixedLayout,
    layout,
    subLayout
  } = configContext.state
  const { dispatch } = configContext

  let headerClass = [
    "navbar",
    "pcoded-header",
    "navbar-expand-lg",
    headerBackColor
  ]
  if (headerFixedLayout && layout === "vertical") {
    headerClass = [...headerClass, "headerpos-fixed"]
  }

  let toggleClass = ["mobile-menu"]
  if (collapseMenu) {
    toggleClass = [...toggleClass, "on"]
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU })
  }

  let moreClass = ["mob-toggler"]
  let collapseClass = ["collapse navbar-collapse"]
  if (moreToggle) {
    moreClass = [...moreClass, "on"]
    collapseClass = [...collapseClass, "d-block"]
  }

  let navBar = (
    <React.Fragment>
      <div className="m-header removePadding">
        <Link
          to="#"
          className={toggleClass.join(" ")}
          id="mobile-collapse"
          onClick={navToggleHandler}
        >
          <span />
        </Link>
        <Link to="#" className="b-brand">
          <img
            id="main-logo"
            src={Logo}
            alt=""
            className="logo"
            style={{ height: "33px", paddingLeft: "10px"}}
          />
        </Link>
        <Link
          to="#"
          className={moreClass.join(" ")}
          onClick={() => setMoreToggle(!moreToggle)}
        >
          <MoreVertical size={15}/>
        </Link>
      </div>
      <div className={collapseClass.join(" ")}>
        <NavLeft />
        <NavMiddle />
        <NavRight />
      </div>
    </React.Fragment>
  )

  if (layout === "horizontal" && subLayout === "horizontal-2") {
    navBar = <div className="container">{navBar}</div>
  }

  return (
    <React.Fragment>
      <header className={headerClass.join(" ")}>{navBar}</header>
    </React.Fragment>
  )
}

export default NavBar
